const WM = "PREVIEW — ALTIORA VENTURES";

export function SlideView({ s, theme, watermark = false, small = false }) {
  const t = theme || {};
  const dark = t.mode === "dark";
  const head = dark ? t.text : t.primary;
  const sz = small ? 0.32 : 1;
  const big = ["title", "closing", "section"].includes(s.layout);
  const st = { background: t.background || "#fff", color: t.text || "#111", fontFamily: t.body_font || "Calibri, sans-serif" };
  return (
    <div className="relative w-full aspect-video overflow-hidden rounded-lg border shadow-sm select-none" style={st} data-testid="slide-view">
      <div className="absolute inset-0" style={{ padding: `${5 * sz}%` }}>
        {big ? (
          <div className="h-full flex flex-col justify-center">
            <p style={{ color: head, fontSize: `${2.4 * sz}rem`, fontWeight: 700, fontFamily: t.heading_font, lineHeight: 1.1 }}>{s.title}</p>
            <div style={{ background: t.accent, height: 4 * sz, width: "100%", margin: `${1 * sz}rem 0` }} />
            {(s.subtitle || s.body) && <p style={{ color: t.muted, fontSize: `${1.1 * sz}rem` }}>{s.subtitle || s.body}</p>}
          </div>
        ) : (
          <>
            <p style={{ color: head, fontSize: `${1.6 * sz}rem`, fontWeight: 700, fontFamily: t.heading_font }}>{s.title}</p>
            <div style={{ background: t.accent, height: 3 * sz, width: "10%", margin: `${0.5 * sz}rem 0 ${0.9 * sz}rem` }} />
            <div style={{ fontSize: `${0.95 * sz}rem` }} className="grid gap-3" >
              {s.layout === "table" && s.table ? (
                <table className="w-full text-left" style={{ fontSize: `${0.8 * sz}rem` }}><thead><tr>{s.table.headers.map((h) => <th key={h} className="border-b p-1">{h}</th>)}</tr></thead>
                  <tbody>{(s.table.rows || []).slice(0, 8).map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} className="border-b p-1">{c}</td>)}</tr>)}</tbody></table>
              ) : s.layout === "chart" && s.chart ? (
                <div className="flex items-end gap-2 h-32" style={{ height: `${8 * sz}rem` }}>
                  {(s.chart.categories || []).map((c, i) => { const v = s.chart.series?.[0]?.values?.[i] || 0; const max = Math.max(1, ...(s.chart.series?.[0]?.values || [1])); return <div key={c} className="flex-1 flex flex-col items-center"><div style={{ background: t.primary, height: `${(v / max) * 100}%`, width: "100%" }} /><span style={{ fontSize: `${0.6 * sz}rem` }}>{c}</span></div>; })}
                </div>
              ) : s.cards?.length ? (
                <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${Math.min(s.cards.length, 4)}, 1fr)` }}>{s.cards.slice(0, 4).map((c) => <div key={c.title} className="rounded p-2" style={{ background: t.primary, color: "#fff" }}><b>{c.title}</b><p style={{ fontSize: `${0.7 * sz}rem` }}>{c.text}</p></div>)}</div>
              ) : (
                <ul className="list-disc pl-5 space-y-1">{(s.bullets || s.left || (s.body ? [s.body] : [])).slice(0, 6).map((b) => <li key={b}>{b}</li>)}</ul>
              )}
            </div>
          </>
        )}
      </div>
      {watermark && <div className="absolute inset-0 grid place-items-center pointer-events-none"><span className="-rotate-12 font-bold tracking-widest" style={{ color: "rgba(201,161,59,.45)", fontSize: `${1.6 * sz + 0.4}rem` }}>{WM}</span></div>}
    </div>);
}
